/**
 * Categorical series colors for the agent-run charts.
 *
 * Fixed order, assigned by position and never cycled — the eight hues below are
 * validated as a set on a white surface (worst adjacent CVD ΔE 9.1, worst
 * adjacent normal-vision ΔE 19.6). Three of them sit under 3:1 contrast, which
 * is why every chart here ships a legend, hover tooltips and a table view of
 * the same numbers.
 *
 * A ninth agent never gets a generated hue: the API folds everything past the
 * top eight into `Other`, which is drawn in neutral ink because it's a
 * residual rather than an identity.
 */
export const SERIES_COLORS = [
  '#2a78d6',
  '#eb6834',
  '#1baf7a',
  '#eda100',
  '#e87ba4',
  '#008300',
  '#4a3aa7',
  '#e34948',
] as const

export const OTHER_LABEL = 'Other'
export const OTHER_COLOR = '#848482'

export function seriesColor(series: string[], name: string): string {
  if (name === OTHER_LABEL) return OTHER_COLOR
  const index = series.filter((s) => s !== OTHER_LABEL).indexOf(name)
  return SERIES_COLORS[index % SERIES_COLORS.length]
}
